import { validateIsSameOrAfter } from 'uplisting-frontend/validators/is-same-or-after';
import { validateIsSameOrBefore } from 'uplisting-frontend/validators/is-same-or-before';

export const BulkClosedForArrivalValidation = {
  from: validateIsSameOrBefore('to'),
  to: validateIsSameOrAfter('from'),
};
